import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { Asset } from '@aptsi-types';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../ada-access-api-endpoints';

interface GetAssetsResponse {
  assets: Asset[];
}

interface GetAssetResponse {
  asset: Asset;
}

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  private readonly assetUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getAssets(): Observable<Asset[]> {
    return this.http.post<GetAssetsResponse>(`${this.assetUrl}${API_ENDPOINTS.ASSET.FETCH}`, { })
      .pipe(
        map(response => response.assets),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getRemainingAssetsAccessFlow(currentPage: number, organizationId: string): Observable<Asset[]> {
    return this.http.post<GetAssetsResponse>(`${this.assetUrl}${API_ENDPOINTS.ASSET.FETCHREMACCESSFLOWASSETS}`,{currentPage, organizationId})
      .pipe(
        map(response => response.assets),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getRemainingAssetsAccessFlowSearch(currentPage: number,searchText: String, filterByHeader: String, organizationId: string): Observable<Asset[]> {
    return this.http.post<GetAssetsResponse>(`${this.assetUrl}${API_ENDPOINTS.ASSET.SEARCHREMACCESSFLOWASSETS}`,{currentPage, searchText, filterByHeader, organizationId})
      .pipe(
        map(response => response.assets),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

generateRemainingAssetsAccessFlow(payload: any): Observable<any> {
  return this.http.post<any>(
    `${this.assetUrl}${API_ENDPOINTS.ASSET.GENERATEREMAININGASSETSACCESSFLOW}`,
    { payload }
  )
  .pipe(
    catchError(error => this.errorHandlingService.handleError(error))
  );
}

  getAsset(assetId: number): Observable<Asset> {
    return this.http.post<GetAssetResponse>(`${this.assetUrl}${API_ENDPOINTS.ASSET.GET}`, { assetId })
      .pipe(
        map(response => response.asset),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  createAsset(
    assetId: number,
    name: string,
    assetType: string,
    description: string,
    assetClassification: string,
    assetLocation: string
  ): Observable<Asset> {
    return this.http.post<Asset>(`${this.assetUrl}${API_ENDPOINTS.ASSET.CREATE}`, {
      assetId,
      name,
      assetType,
      description,
      assetClassification,
      assetLocation
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  updateAsset(
    assetId: number,
    name: string,
    assetType: string,
    description: string,
    assetClassification: string,
    assetLocation: string
  ): Observable<Asset> {
    return this.http.post<Asset>(`${this.assetUrl}${API_ENDPOINTS.ASSET.UPDATE}`, {
      assetId,
      name,
      assetType,
      description,
      assetClassification,
      assetLocation
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  deleteAsset(assetId: string): Observable<Asset[]> {
    return this.http.post<Asset[]>(`${this.assetUrl}${API_ENDPOINTS.ASSET.DELETE}`, { assetId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }
}
